import { render, staticRenderFns } from "./TagChip.vue?vue&type=template&id=5acddf02&scoped=true&lang=pug&"
import script from "./TagChip.vue?vue&type=script&lang=js&"
export * from "./TagChip.vue?vue&type=script&lang=js&"
import style0 from "./TagChip.vue?vue&type=style&index=0&id=5acddf02&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acddf02",
  null
  
)

export default component.exports